<template>
  <div>
    <div class="b-banner-con">
      <v-header></v-header>
      <v-nav></v-nav>
    </div>
    <v-breadcrumb></v-breadcrumb>
    <!-- 主题内容 -->
    <div class="b-center-container">
      <!-- 富文本 -->
      <div class="b-container">
        <div class="b-center-main">
          <div class="b-richtext">
            <p v-html="richText"></p>
          </div>
        </div>
      </div>
    </div>
    <v-contact></v-contact>
      <!--
      <v-footer></v-footer>
      <v-copy></v-copy>
      -->
  </div>
</template>
<script>
/* eslint-disable */
import Header from "@/components/header/en/";
import Nav from "@/components/nav/en/";
import Breadcrumb from "@/components/breadcrumb/en/"
import Contact from "@/components/contact/en/";
export default {
  data () {
    return {
      richText: '',
    };
  },
  mounted () {
    this.richText = '<p style="text-align: left; "><span style="font-size: 22px; border-bottom: solid 3px #033d80;">STAR</span></p>'
      + '<p style="margin-top : 30px; margin-bottom : 30px"><span style="font-size: 16px;">SJTU Trans-med Awards Research (STAR) program provides scientific, technological and clinical researchers with fund to carry out frontier explorations oriented to clinical problems and demands, to support talent training and cultivation and stimulate original innovation and development of interdisciplinary research. </span></p>'

      +'<p style="margin-left : 10px; text-align: center"><img src="https://nbcloud-repairorder-image.oss-cn-beijing.aliyuncs.com/star1.png" style="width: 750px; margin-right: 16px;margin-bottom: 10px;" width="960px"  border="0" vspace="0" alt=""></p>'
      // +'<p style="margin-bottom : 0px; margin-left: 30px; text-align: center"><img src="https://nbcloud-repairorder-image.oss-cn-beijing.aliyuncs.com/star2.png" style="width: 720px; margin-bottom: 0px;" border="0" vspace="0" alt=""></p>'

      + '<div style="width: 100%">'
      + '<div id="right" style="float:left ; margin-top: 20px; width:95%; height:100%;">'
      + '<ul>' +
      '<li style="margin-left: 10px; margin-bottom: 10px; font-size: 16px; color: #033d80;">▶ Youth Project</li>' +
      '<li style="margin-left: 10px; margin-bottom : 30px;font-size: 16px;">Support young scientific and technological researchers under the age of 40 at School of Medicine(SJTU) and its affiliated hospitals to carry out independent and cooperative original cross-research.</li>' +
      '<li style="margin-left: 10px; margin-bottom: 10px; font-size: 16px; color: #033d80;">▶ Key project</li>' +
      '<li style="margin-left: 10px; margin-bottom : 30px;font-size: 16px;">Support researchers to carry out independent cross-research oriented by clinical issues, and arrange pre-research on major national key projects.</li>' +
      '<li style="margin-left: 10px; margin-bottom: 10px; font-size: 16px; color: #033d80;">▶ Major project</li>' +
      '<li style="margin-left: 10px; margin-bottom : 30px;font-size: 16px;">Generate a batch of new research directions in the field of clinical application of  key technologies by applying the integration of “basic research-clinical research-technology application”.</li>' +
      '</ul>'
      + '</div>'
      // + '<div id="left" style="float:left ;margin-left : 60px; margin-top: 20px;  width:45%; height:100%;">'
      // + '<img src="https://nbcloud-repairorder-image.oss-cn-beijing.aliyuncs.com/start3.jpg" style="height:303px;" alt="">'
      // + '</div>'
      + '</div>'
      + '<p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p>'
      + '<p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p>'
      + '<p>&nbsp;</p><p>&nbsp;</p>'

    //+'<p style="margin-bottom : 0px; text-align: center"><img src="https://nbcloud-repairorder-image.oss-cn-beijing.aliyuncs.com/star3.png" style="width: 960px; margin-right: 16px;margin-bottom: 16px;" width="960px"  border="0" vspace="0" alt=""></p>'

  },
  components: {
    "v-header": Header,
    "v-nav": Nav,
    "v-breadcrumb": Breadcrumb,
    "v-contact": Contact,
  }
};
</script>
<style lang="scss">
  @media screen and (max-width:600px) {
	.b-banner-con{
	    //padding: 22px 0;
	    background: url(../../../assets/img/banner_bg.png) no-repeat!important;
	    background-size: cover!important;
	    .b-header{
	      margin-bottom: 0px;
	    }
	    height: 134px;
	    width: 1440px;
	}
  }

  @media screen and (min-width:960px) {
    .b-banner-con{
	    //padding: 22px 0;
	    background: url(../../../assets/img/banner_bg.png) no-repeat!important;
	    background-size: cover!important;
	    .b-header{
	      margin-bottom: 0px;
	    }
	    height: 134px;
    }
  }
.b-richtext {
  text-align:left;
  b,
  strong {
    font-weight: 700;
  }
  p {
    margin: 0 0 10px;
    line-height: 24px;
  }
  line-height: 24px;
}
</style>



// WEBPACK FOOTER //
// src/pages/event1/en/index.vue